import clsx from 'clsx';
import * as React from 'react';
import { ImageWithFocalPointFieldsFragment } from 'types/generated';
import { ImageWithFocalPoint } from '../ImageWithFocalPoint';

type Props = {
  images: (ImageWithFocalPointFieldsFragment | null)[];
};

const Images = ({ images }: Props) => {
  const image1 = images[0];
  const image2 = images[1];
  const image3 = images[2];

  return (
    <div className="relative flex flex-col gap-24 md:grid md:h-[450px] md:grid-cols-3 md:grid-rows-2">
      {image1 && (
        <div
          className={clsx('relative h-[276px] md:col-span-2 md:row-span-2 md:h-full', {
            'md:col-span-3': !image2 && !image3,
          })}
        >
          <ImageWithFocalPoint image={image1} className="rounded-28" sizes={{ breakpoints: { md: '800px' } }} />
        </div>
      )}
      {image2 && (
        <div
          className={clsx('relative col-start-3', {
            'row-span-2 h-full': !image3,
            'h-[215px]': image3,
          })}
        >
          <ImageWithFocalPoint image={image2} className="rounded-28" sizes={{ breakpoints: { md: '400px' } }} />
        </div>
      )}
      {image3 && (
        <div className="relative col-start-3 row-start-2 h-[215px]">
          <ImageWithFocalPoint image={image3} className="rounded-28" sizes={{ breakpoints: { md: '400px' } }} />
        </div>
      )}
    </div>
  );
};
export default Images;
